import React from "react";
import { OneToMany, OneToOne, ManyToMany } from "./CardinalityShapes";

/* refactored - ali */
const SelectedCardinality = (props) => {
	const { selected, firstEntityName, secondEntityName, onClick, showSelected, orgName, projectName, fromEntity, toEntity, isAccessedFromWorkspace, selectEntity } = props;

	if (selected === "1-1") {
		return (
			<div data-testid="selected-cardinality">
				<div className={`p-2 ${selected === "1-1" && showSelected && "border-info"}`}>
					<OneToOne onClick={onClick} orgName={orgName} projectName={projectName} fromEntity={fromEntity} toEntity={toEntity} left={firstEntityName} right={secondEntityName} isAccessedFromWorkspace={isAccessedFromWorkspace} selectEntity={selectEntity}></OneToOne>
				</div>
			</div>
		);
	}

	if (selected === "1-*") {
		return (
			<div data-testid="selected-cardinality">
				<div className={`p-2 ${selected === "1-*" && showSelected && "border-info"}`}>
					<OneToMany onClick={onClick} orgName={orgName} projectName={projectName} fromEntity={fromEntity} toEntity={toEntity} left={firstEntityName} right={secondEntityName} isAccessedFromWorkspace={isAccessedFromWorkspace} selectEntity={selectEntity}></OneToMany>
				</div>
			</div>
		);
	}

	return (
		<div data-testid="selected-cardinality">
			<div className={`p-2 ${selected === "*-*" && showSelected && "border-info"}`}>
				<ManyToMany onClick={onClick} orgName={orgName} projectName={projectName} fromEntity={fromEntity} toEntity={toEntity} left={firstEntityName} right={secondEntityName} isAccessedFromWorkspace={isAccessedFromWorkspace} selectEntity={selectEntity}></ManyToMany>
			</div>
		</div>
	);
};

export default SelectedCardinality;
